const state = {
  // baseUrl: 'http://10.0.1.21:6107/BUSWEBSITE',
  // baseUrl: 'http://10.0.1.15:6107/BUSWEBSITE',
  baseUrl: '',
  // baseUrl: 'http://10.0.1.252:40006/BUSWEBSITE',
  // baseUrl: 'http://10.0.1.15:6107/BUSWEBSITE',
  // baseUrl: 'http://10.0.1.252:40008/BUSWEBSITE',
  //logoUrl: 'http://10.0.1.252:40006/skin/bank/',
  logoUrl: '/skin/bank/',
  webName: '保理金融平台',
  servePhone: '400-100-8899',
  workTime: '08:00-20:00',
  serveEmail: 'service@jinhai.com',
  copyRightCh: '北京金海明天软件技术有限公司 京ICP备17060142号',
  copyRightEn: 'Copyright © 2015 goldensearsoft.com,All Right Reserved.'
}

export default {
  state
}


// WEBPACK FOOTER //
// ./src/store/modules/common.js